import type { FunctionComponent } from 'react';

import { LimitConnected } from '../limit/LimitConnected';

import { BetLimitsTable, type BetLimitsTableProps } from './BetLimitsTable';

export interface BetLimitsTableConnectedProps extends Omit<BetLimitsTableProps, 'renderLimit'> {}

export const BetLimitsTableConnected: FunctionComponent<BetLimitsTableConnectedProps> = ({ ...rest }) => {
  return <BetLimitsTable renderLimit={(limits) => <LimitConnected limits={limits} />} {...rest} />;
};
